import React from 'react';
import { Fade, Typography } from '@mui/material';
import SquareIcon from '@mui/icons-material/Square';
import clsx from 'clsx';
import { useAppSelector } from '../../Store/hooks';
import { SelectStatus } from '../../Store/Selectors';
import './tracking-errors.scss';

export const TrackingErrors: React.FC = () => {
    const shipmentStatus = useAppSelector(SelectStatus);

    // Zusätzliche Logik für statusCode "NOT_FOUND_HINT"
    const statusCode = shipmentStatus.currentStatus?.statusCode;
    const isBackendError = shipmentStatus.error.status && shipmentStatus.error.status !== 405;
    const isNotFound = String(statusCode) === 'NOT_FOUND_HINT';

    const isVisible = isBackendError || isNotFound;

    // Fehlertext abhängig vom Fall
    const errorText = isNotFound
        ? 'Für Ihre Sendungsnummer konnte kein Zustellstatus gefunden werden'
        : shipmentStatus.error.message;

    const errorReasons = [
        'Sie haben sich vertippt.',
        'Ihre Sendung hat nicht die Option Sendungsverfolgung.',
        'Sie haben bei Ihrer Sendungsnummer Sonderzeichen verwendet; bitte geben Sie die Sendungsnummer ohne Klammern () ein.',
        'Die Sendung ist älter als 6 Monate.'
    ];

    return (
        <>
            {isVisible && (
                <Fade in={isVisible} timeout={700}>
                    <div
                        className={clsx([
                            'tracking-errors py-2 px-4 rounded mt-2 align-items-center',
                            { 'tracking-erros-visible': isVisible }
                        ])}
                    >
                        <Typography sx={{ mt: 1 }} variant="h6" component="div">
                            {errorText}
                        </Typography>
                        <div className="m-auto text-left">
                            <Typography sx={{ mt: 2 }} component="div">Mögliche Ursachen:</Typography>
                            <div>
                                {errorReasons.map((text, ind) => (
                                    <div key={ind}>
                                        <SquareIcon className="square-box align-middle px-1" />
                                        <Typography className="align-middle" component="span">{text}</Typography>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </Fade>
            )}
        </>
    );
};
